import { useTheme } from "@mui/material"

export default function Basket({size = 20}) {
    const theme = useTheme();

    const baseWidth = 20;
    const baseHeight = 20;
  
    const height = (baseHeight * size) / baseWidth;

    return (
        <svg 
            width={baseWidth}
            height={height} 
            viewBox="0 0 20 20" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path 
                d="M19.2005 10.3826H7.86264C7.19198 10.3826 6.64347 9.85675 6.61938 9.18272C6.60513 8.7831 6.6115 8.39128 6.63869 8.00051H6.08964C5.91308 7.91046 1.43599 5.62698 1.10685 5.45913V0.553427C1.10685 0.247758 0.859095 0 0.553427 0C0.247758 0 0 0.247758 0 0.553427C0 0.727955 0 10.3044 0 10.6482C0 10.9539 0.247802 11.2017 0.553427 11.2017H1.51798V11.526C1.51798 11.7241 1.67861 11.8848 1.87678 11.8848H3.67661C3.87478 11.8848 4.03541 11.7241 4.03541 11.526V11.2017H16.0815V11.526C16.0815 11.7241 16.2421 11.8848 16.4403 11.8848H18.2401C18.4383 11.8848 18.5989 11.7241 18.5989 11.526V11.2017H19.4466C19.7522 11.2017 20 10.9539 20 10.6482V10.0934C19.783 10.2751 19.5036 10.3826 19.2005 10.3826Z" 
                fill={theme.palette.rgd.primary} 
            />
            <path 
                d="M3.79139 5.43434C4.60816 5.43434 5.27028 4.77222 5.27028 3.95545C5.27028 3.13868 4.60816 2.47656 3.79139 2.47656C2.97462 2.47656 2.3125 3.13868 2.3125 3.95545C2.3125 4.77222 2.97462 5.43434 3.79139 5.43434Z" 
                fill={theme.palette.rgd.primary} 
            />
            <path 
                d="M5.86072 6.75313C6.7041 7.06774 6.21292 6.88453 6.74297 7.08226C6.80075 6.72027 6.87491 6.3814 6.96036 6.06581L6.76227 5.75793L8.91701 7.84081C9.08405 8.00232 9.32814 8.07688 9.5658 8.02477L12.3506 7.41418C12.7348 7.32993 12.9793 6.94997 12.8948 6.56434C12.8948 6.56425 12.8947 6.56416 12.8947 6.56407C12.8123 6.18881 12.4379 5.93507 12.0465 6.01986C12.046 6.01999 12.0455 6.01999 12.0449 6.02012L9.63385 6.54876C9.41044 6.33279 7.76504 4.74228 7.53304 4.51803C7.72271 4.12315 7.91566 3.79973 8.08408 3.54843L7.18173 3.21181C6.65646 3.01586 6.08563 3.29182 5.89658 3.79854L5.89654 3.79862L5.27382 5.46789C5.27378 5.46807 5.27373 5.4682 5.27364 5.46838C5.08322 5.97961 5.34001 6.55885 5.86072 6.75313Z" 
                fill={theme.palette.rgd.primary} 
            />
            <path 
                d="M11.9012 5.34666C12.6699 5.17811 13.4062 5.68049 13.5668 6.41327C13.7315 7.16447 13.2572 7.91306 12.5002 8.07895L9.71548 8.68953C9.07337 8.83033 8.52185 8.48362 8.34387 8.20712L7.63787 7.10988C7.53418 7.71453 7.4799 8.39454 7.50686 9.1495C7.51377 9.34245 7.6721 9.4955 7.86522 9.4955H19.203C19.379 9.4955 19.5289 9.36795 19.5572 9.1943L19.8334 7.49511C20.0411 6.21762 19.2629 4.99242 18.0194 4.63345C16.0802 4.07365 13.1883 3.375 10.8334 3.375C10.2585 3.375 9.71606 3.41657 9.22678 3.51198C9.22678 3.51198 8.7418 4.0102 8.28591 4.99658L9.74545 5.81929L11.9012 5.34666Z" 
                fill={theme.palette.rgd.primary} 
            />
        </svg>

    )
}